export default "__VITE_ASSET__6daaf81b__"